import { Component } from '@angular/core';
import { Message } from 'primeng/components/common/api';
import { Router, NavigationEnd, RoutesRecognized } from '@angular/router';
import { filter, pairwise } from 'rxjs/operators';
import { LastRecordAccessService } from '../common/services/last-record-access.service';

@Component({
    templateUrl: './main.component.html'
    //styleUrls: ["./main.component.style.css"]
})

export class MainComponent {
    previousUrl: string;
    currentUrl: string;
    isLoading: boolean;
    public growlMessage: Message[] = [];
    constructor(router: Router, private lastRecordAccessService: LastRecordAccessService) {
        router.events
            .pipe(filter((evt: any) => evt instanceof RoutesRecognized), pairwise())
            .subscribe((events: RoutesRecognized[]) => {
                //console.log('previous url', events[0].urlAfterRedirects);
                //console.log('current url', events[1].urlAfterRedirects);
                this.currentUrl = events[1].urlAfterRedirects;
                this.previousUrl = events[0].urlAfterRedirects;
                if (this.currentUrl.search('/patient-records/') > -1 && this.currentUrl.search('/patient-features') > -1 && this.currentUrl.search('/patient-features/') == -1 && this.previousUrl.search('/patient-features') == -1) {
                    //console.log(this.currentUrl.search('/patient-records/'));
                    //console.log(this.currentUrl.search('/patient-features'));
                    //console.log(this.currentUrl.search('/patient-features/'));
                    //console.log(this.previousUrl.search('/patient-features'));
                    let patientKey: string;
                    patientKey = (this.currentUrl.split('/')[2]);
                    //console.log(patientKey);
                    this.lastRecordAccessService.insertRecordLRA(patientKey)
                        .subscribe(data => {
                        if (data.status === 200) {
                        }
                    },
                        err => { this.isLoading = false; this.growlMessage = []; this.growlMessage.push({ severity: 'error', summary: 'Failed to Save Last Access Information', detail: '' }); },
                        () => { this.isLoading = false; });
                }
                else if (this.currentUrl.search('patient-features') == -1 && this.previousUrl.search('/patient-records/') > -1) {
                    this.lastRecordAccessService.updateLRA()
                        .subscribe(data => {
                            if (data.status === 200) {
                            }
                        },
                            err => { this.isLoading = false; this.growlMessage = []; this.growlMessage.push({ severity: 'error', summary: 'Failed to Save Last Access Information', detail: '' }); },
                            () => { this.isLoading = false; });
                }
            });
    }
    //ngOnChanges() {
    //    console.log('ngOnChanges');
    //}
    //ngOnInit() {
    //    console.log('ngOnInit');
    //}
    //ngDoCheck() {
    //    console.log('ngDoCheck');
    //    console.log(document.location.ancestorOrigins);
    //    console.log(document.URL);
    //}
    //ngAfterContentInit() {
    //    console.log('ngAfterContentInit');
    //}
    //ngAfterContentChecked() {
    //    console.log('ngAfterContentChecked');
    //}
    //ngAfterViewInit() {
    //    console.log('ngAfterViewInit');
    //}
    //ngAfterViewChecked() {
    //    console.log('ngAfterViewChecked');
    //}
    ngOnDestroy() {
        this.lastRecordAccessService.updateLRA()
            .subscribe(data => {
                if (data.status === 200) {
                }
            },
                err => { this.isLoading = false; this.growlMessage = []; this.growlMessage.push({ severity: 'error', summary: 'Failed to Save Last Access Information', detail: '' }); },
                () => { this.isLoading = false; });
    }
}
